import { createClient } from 'contentful'

import { contentful } from '@/constants/configs'

export const contentfulClient = createClient({
  space: contentful.space,
  accessToken: contentful.token
})
